import React from 'react';
import PropTypes from 'prop-types';

import { Recaptcha } from '../../helpers/Recaptcha';

const IPropTypes = {
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  onExpiry: PropTypes.func,
};

const defaultProps = {
  onSuccess: () => {},
  onError: () => {},
  onExpiry: () => {},
};

const BASE_RECAPTCHA_ID = 'recaptchaId';

class RecaptchaComponent extends React.Component {
  constructor(props) {
    super(props);
    const randomId = Math.random().toString().replace('.', '');
    this.id = `${BASE_RECAPTCHA_ID}-${randomId}`;
  }

  componentDidMount() {
    Recaptcha.onReady(() => {
      Recaptcha.render(this.id);
    });
    this._setCallbacks();
  }

  componentDidUpdate(prevProps) {
    Recaptcha.offError(prevProps.onError);
    Recaptcha.offSuccess(prevProps.onSuccess);
    Recaptcha.offExpiry(prevProps.onExpiry);
    this._setCallbacks();
  }

  componentWillUnmount() {
    Recaptcha.offError(this.props.onError);
    Recaptcha.offSuccess(this.props.onSuccess);
    Recaptcha.offExpiry(this.props.onExpiry);
  }

  _setCallbacks() {
    Recaptcha.onError(this.props.onError);
    Recaptcha.onSuccess(this.props.onSuccess);
    Recaptcha.onExpiry(this.props.onExpiry);
  }

  render() {
    return (
      <div id={this.id} />
    );
  }
}

RecaptchaComponent.propTypes = IPropTypes;
RecaptchaComponent.defaultProps = defaultProps;

export { RecaptchaComponent };



// WEBPACK FOOTER //
// ./src/common/recaptcha-component/RecaptchaComponent.jsx